import { render } from "./DecayResultTable.vue?vue&type=template&id=700545e6&scoped=true"
import script from "./DecayResultTable.vue?vue&type=script&lang=js"
export * from "./DecayResultTable.vue?vue&type=script&lang=js"

import "./DecayResultTable.vue?vue&type=style&index=0&id=700545e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700545e6"]])

export default __exports__